import Catalog from './catalog';
import { useSearchParams } from 'react-router-dom';

function NewItkSearch() {
    const [params] = useSearchParams();
    return (
        <div className="col-md-9">
            <Catalog key={params.get('q')} globalMode />
        </div>
    );
}

export default NewItkSearch;
